import React from "react";

import Searchbar from "../../utils/searchbar/Searchbar";
import SearchReviews from "../../search/SearchReviews";

class ReviewsSearch extends React.PureComponent {
	render() {
		return (
			<React.Fragment>
				<Searchbar
					placeholder={"Search reviews"}
					component={SearchReviews}
					searchEndpoint={"search/reviews"}
					basePath={this.props.location.pathname + "/edit"}
					{...this.props}
					userType="admin"
				/>
			</React.Fragment>
		);
	}
}

export default ReviewsSearch;


// WEBPACK FOOTER //
// ./src/components/admin/reviews/ReviewsSearch.js